//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const PoisonActiveTimersOnPurgeGrace: FeatureFlag = {"Id":"PoisonActiveTimersOnPurgeGrace","Label":"(KILL)[10.27]PoisonActiveTimersOnPurgeGrace","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch. When active, moving a submission into purge grace (or pre-purging it directly) also poisons its active timers so they stop firing.","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
